import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, ModalTitles, } from "./styles";
import { IconClose } from "../icons";
import { createPortal } from "react-dom";
import { AnimatePresence } from "framer-motion";
var Modal = forwardRef(function Modal(_a, ref) {
    var open = _a.open, toggle = _a.toggle, overlayStyles = _a.overlayStyles, children = _a.children, props = __rest(_a, ["open", "toggle", "overlayStyles", "children"]);
    var modifiedChildren = React.Children.map(children, function (child) {
        if (React.isValidElement(child) && child.props.hasClose) {
            // @ts-ignore
            return React.cloneElement(child, { toggle: toggle });
        }
        return child;
    });
    return createPortal(_jsx(AnimatePresence, { children: open && (_jsx(ModalOverlay, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.3 }, ref: ref, style: overlayStyles, onClick: function (e) {
                e.stopPropagation();
                toggle === null || toggle === void 0 ? void 0 : toggle();
            }, children: _jsx(ModalContent, __assign({ initial: { scale: 0.9 }, animate: { scale: 1 }, exit: { scale: 0.9 }, transition: { duration: 0.3 }, onClick: function (e) { return e.stopPropagation(); } }, props, { children: modifiedChildren })) })) }), document.body);
});
var Header = function (_a) {
    var children = _a.children, hasClose = _a.hasClose, toggle = _a.toggle, props = __rest(_a, ["children", "hasClose", "toggle"]);
    return (_jsxs(ModalHeader, __assign({}, props, { children: [_jsx(ModalTitles, { children: children }), hasClose && _jsx(IconClose, { onClick: function () { return toggle === null || toggle === void 0 ? void 0 : toggle(); } })] })));
};
var Body = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return _jsx(ModalBody, __assign({}, props, { children: children }));
};
var Footer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return _jsx(ModalFooter, __assign({}, props, { children: children }));
};
var ModalComponent = Object.assign(Modal, { Header: Header, Body: Body, Footer: Footer });
export default ModalComponent;
//# sourceMappingURL=index.js.map